const orderDetails = {
  'orderDetails.title': 'Order Details',

  'orderDetails.tab.goodsList': 'Product List',
  'orderDetails.tab.payments': 'Payment Information',
  'orderDetails.tab.shipments': 'Shipment Information',
  'orderDetails.tab.logistics': 'Logistics Information',
  'orderDetails.tab.operationLog': 'Operation Log',

  'orderDetails.fetch.orderId.empty': 'Order ID cannot be empty',

  'orderDetails.content.orderInfo.title': 'Order Information',
  'orderDetails.export.productList': 'Export Product List',
  'orderDetails.export.exporting': 'Exporting product list...',
  'orderDetails.export.success.message': 'Export Successful',
  'orderDetails.export.success.description': 'Product list has been successfully exported, please check your downloads folder',
  'orderDetails.export.failed': 'Export failed, please try again later',

  'orderDetails.content.customerInfo.title': 'Customer Information',
  'orderDetails.content.customerInfo.shopId': 'Store ID',
  'orderDetails.content.customerInfo.shopName': 'Store Name',

  'orderDetails.content.shippingInfo.title': 'Shipping Information',
  'orderDetails.content.shippingInfo.recipientName': 'Recipient Name',
  'orderDetails.content.shippingInfo.phone': 'Phone Number',
  'orderDetails.content.shippingInfo.postalCode': 'Postal Code',
  'orderDetails.content.shippingInfo.email': 'Email',
  'orderDetails.content.shippingInfo.address': 'Shipping Address',

  'orderDetails.content.amountInfo.title': 'Amount Information',
  'orderDetails.content.amountInfo.goodsAmount': 'Product Payment',
  'orderDetails.content.amountInfo.otherAmount': 'Other Fees',

  'orderDetails.feeType': 'Fee Type',
  'orderDetails.feeAmount': 'Amount',

  'orderDetails.productList.partsNum': 'Part Number',
  'orderDetails.productList.productTitle': 'Product Details',
  'orderDetails.productList.replacePartsNum': 'Replacement Part Number',
  'orderDetails.productList.unitPrice': 'Unit Price',
  'orderDetails.productList.totalPrice': 'Total Price',
  'orderDetails.productList.totalQuantity': 'Total Quantity',
  'orderDetails.productList.shippedQuantity': 'Shipped Quantity',

  'orderDetails.operationRecord.operationType': 'Operation Type',
  'orderDetails.operationRecord.operationUser': 'Operator',
  'orderDetails.operationRecord.operationDate': 'Operation Date',

  'orderDetails.payments.paymentId': 'Payment ID',
  'orderDetails.payments.paymentMethod': 'Payment Method',
  'orderDetails.payments.paymentAmount': 'Payment Amount',
  'orderDetails.payments.paymentDate': 'Payment Date',
  'orderDetails.payments.payer': 'Payer',
  'orderDetails.payments.payerContact': 'Contact Information',
  'orderDetails.payments.description': 'Description',

  'orderDetails.shipments.shipmentId': 'Shipment ID',
  'orderDetails.shipments.shippingMethod': 'Shipping Method',
  'orderDetails.shipments.shippingStatus': 'Shipping Status',
  'orderDetails.shipments.shippingDate': 'Shipping Date',
};

export default orderDetails;
